import {SSOButton} from "../../../common/SSOButton";
import React, {useEffect} from "react";
import {BasicProps} from "../../../Main";
import "./HubLogin.css";

export const HubLogin: React.FC<BasicProps> = (props) => {

    useEffect(() => {
        props.setShowCover(false); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <div className="hub-login-page">
            <main className="hub-login-main">
                <div className="hub-login-wrap hub-login-column">
                    <div className="hub-login-stepper" aria-label="Setup progress">
                        <span className="current"><i />1. ACCOUNT</span>
                        <span><i />2. PROFILE AND CV</span>
                    </div>
                    <div className="hub-login-heading">
                        <h1>Step 1 of 2: sign in or create an account</h1>
                        <p>Sign in with your Samaggi Account to access your profile, applications, and My SACC.</p>
                    </div>
                    <section className="hub-login-card" aria-labelledby="hub-login-card-title">
                        <h2 id="hub-login-card-title">Continue with your Samaggi Account</h2>
                        <p>Use your existing account, or create a new one if you are joining CFAS for the first time.</p>
                        <SSOButton textVariant="continue" fallbackNav="/cfas/hub/register" openInNewTab={false} />
                        <SSOButton textVariant="sign-up" fallbackNav="/cfas/hub/register" openInNewTab={false} />
                        <p className="hub-login-note">Your profile and CV are only shown to employers you apply to.</p>
                    </section>
                </div>
            </main>

            <footer className="hub-login-footer">
                <div className="hub-login-wrap">
                    <span><strong>Samaggi Samagom</strong>, CFAS, the career and SACC platform</span>
                    <span className="hub-login-footer-links">
                        <a href="mailto:careers@samaggisamagom.com">careers@samaggisamagom.com</a>
                        <a href="/privacy">Privacy</a>
                        <a href="/help">Help</a>
                    </span>
                </div>
            </footer>
        </div>
    )
}

export default HubLogin